import { Mutation } from 'react-apollo'
import closeLoan, {
  CloseLoan,
  CloseLoanInput
} from '../../graphql/mutations/closeLoan'
import withMutation from './withMutation'

class CloseLoanMutation extends Mutation<CloseLoan, CloseLoanInput> {}

export default withMutation(closeLoan)(CloseLoanMutation)



// WEBPACK FOOTER //
// ./src/components/mutations/CloseLoanMutation.tsx